// import logo from './logo.svg';
import './App.css';
import Header from './components/Header/Header';
import PandoraRouter from './routes';

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faFontAwesome, faStudiovinari } from '@fortawesome/free-brands-svg-icons'
// import { faHatCowboy } from '@fortawesome/pro-thin-svg-icons'
// import { faHatChef } from '@fortawesome/sharp-solid-svg-icons'

library.add(fas, faTwitter, faFontAwesome, faStudiovinari);

function App() {
  
  return (
    <div className="App">
      <Header />
      <PandoraRouter />
    </div>
  );
}

export default App;
